import type {PillProps} from 'src/design/atoms/Pill';

/**
 * Pill preset for a boolean active/inactive status.
 * @registry `(active?: boolean) => PillProps` — Active/green, Inactive/yellow, Invalid/red.
 *
 * Ported from `shared/constants/PillConstants`. Behavior kept verbatim.
 */
export const ActiveInactivePills = (active?: boolean): PillProps => {
  if (active === true) {
    return {
      text: 'Active',
      color: 'green',
    };
  }

  if (active === false) {
    return {
      text: 'Inactive',
      color: 'yellow',
    };
  }

  return {
    text: 'Invalid',
    color: 'red',
  };
};

/**
 * Pill preset for a boolean verification status.
 * @registry `(isVerified?: boolean) => PillProps` — Verified/green, Unverified/yellow, Invalid/red.
 *
 * Ported from `shared/constants/PillConstants` (`UnverifiedPills`), renamed since it
 * returns "Verified" on the happy path.
 */
export const VerificationPills = (isVerified?: boolean): PillProps => {
  if (isVerified === true) {
    return {
      text: 'Verified',
      color: 'green',
    };
  }

  if (isVerified === false) {
    return {
      text: 'Unverified',
      color: 'yellow',
    };
  }

  return {
    text: 'Invalid',
    color: 'red',
  };
};

/**
 * Pill preset for a knowledge-article published status.
 * @registry `(published?: boolean) => PillProps` — Published/green, Draft/gray, Invalid/red.
 */
export const PublishedDraftPills = (published?: boolean): PillProps => {
  if (published === true) {
    return {
      text: 'Published',
      color: 'green',
    };
  }

  if (published === false) {
    return {
      text: 'Draft',
      color: 'gray',
    };
  }

  return {
    text: 'Invalid',
    color: 'red',
  };
};
